import { BaseViewStore, BaasicDropdownStore } from "core/stores";
import { uuid } from "core/utils";
import { action, observable, runInAction } from 'mobx';
import _ from "lodash";

class FacilityOrderPatientNewFlowUSIntakeSinglePagePreviewViewStore extends BaseViewStore {
    @observable accessor hospitalClassName = "";
    @observable accessor dischargedClassName = "";
    @observable accessor expiredClassName = "";
    activeClassName = "";
    @observable accessor activeClassName = "";
    @observable accessor disabledPatient = false;
    @observable accessor isDisabledTableInactiveOption = false;
    @observable accessor oldTemplate;
    @observable accessor insuranceInfo = "";
    @observable accessor patientNote = "";
    @observable accessor productStore;
    @observable accessor patient = null;
    @observable accessor groupByPatient;
    @observable accessor isQtyChange = false;
    @observable accessor templateExpanded = { id: null, expanded: false };

    inactiveOptions = [{ id: "15", name: "Hospital" }, { id: "17", name: "Discharged" }, { id: "18", name: "Expired" }, { id: "0", name: "Active" }];

    constructor(rootStore, componentsProps) {
        super(rootStore);

        this.rootStore = rootStore;
        this.id = componentsProps.id;
        this.facilityOrder = componentsProps.facilityOrder;
        this.facilityOrderPatient = componentsProps.facilityOrderPatient;

        _.forEach(componentsProps.facilityOrderTemplates, (facilityOrderTemplate) => {
            _.forEach(facilityOrderTemplate.facilityOrderTemplateItems, (facilityOrderTemplateItem) => {
                facilityOrderTemplateItem.lastTemplateQuantity = facilityOrderTemplateItem.templateQuantity;
                facilityOrderTemplateItem.lastOrderQuantity = facilityOrderTemplateItem.orderQuantity;
                facilityOrderTemplateItem.lastNote = facilityOrderTemplateItem.note;
            });
        });
        this.facilityOrderTemplates = componentsProps.facilityOrderTemplates;

        this.patient = componentsProps.facilityOrderTemplates[0].patient;
        this.isMasterPatient = this.facilityOrder.facility.masterPatientId == this.patient.patientKey;
        this.sendAgoraPo = this.facilityOrder.facility.sendAgoraPo;
        this.fetchTemplatesByPatientId = componentsProps.fetchTemplatesByPatientId;
        this.fetchTemplatePartialData = componentsProps.fetchTemplatePartialData;
        this.checkIsUSIntakeCompleted = componentsProps.checkIsUSIntakeCompleted;
        this.checkIsReviewed = componentsProps.checkIsReviewed;
        this.lookups = componentsProps.lookups;
        this.pageViewStore = componentsProps.pageViewStore;
        this.groupByPatient = this.pageViewStore.groupByPatient;

        if (this.facilityOrderTemplates && this.facilityOrderTemplates.some(i => i.templateId)) {
            this.oldTemplate = this.facilityOrderTemplates.filter(i => i.templateId)[0];
        }

        this.selectedStatusAbrv = componentsProps.selectedStatusAbrv;
        this.inactiveOptionStore = new BaasicDropdownStore(
            {
                multi: false,
                filterable: false,
            },
            {
                fetchFunc: () => {
                    return this.inactiveOptions;
                },
            }
        );

        this.fetch([this.initialize()]);
    }

    @action.bound
    async initialize() {
        this.getPatientStatusButtonClassName();
        this.insuranceInfo = this.facilityOrderPatient && this.facilityOrderPatient.insuranceInfo;
        this.patientNote = this.facilityOrderPatient && this.facilityOrderPatient.note;
    }

    @action.bound
    showPreviousFlag() {
        return this.facilityOrderPatient && this.facilityOrderPatient.facilityOrderPatientInitial && (this.facilityOrderPatient.activeStatus != this.facilityOrderPatient.facilityOrderPatientInitial.activeStatus);
    }

    @action.bound
    getPatientStatusButtonClassName(inactiveOptionId = null) {
        this.hospitalClassName = "";
        this.dischargedClassName = "";
        this.expiredClassName = "";
        this.activeClassName = "";
        this.inactiveOptionStoreId = "";

        this.inactiveOptions
            .filter((i) => !inactiveOptionId || i.id === inactiveOptionId)
            .forEach((item) => {
                if (this.selectedStatusAbrv === "in-progress") {
                    if (item.name === "Hospital" && this.facilityOrderPatient.activeStatus === 'Hospital') {
                        this.hospitalClassName = "is-active--alt";
                    }
                    else if (item.name === "Active" && this.facilityOrderPatient.activeStatus !== 'Hospital') {
                        this.inactiveOptionStoreId = "0";
                        this.activeClassName = "is-active";
                    }
                }
                else if (this.selectedStatusAbrv === "new-order" || this.selectedStatusAbrv === "change" || this.selectedStatusAbrv === "no-change") {
                    if (item.name === "Active") {
                        this.inactiveOptionStoreId = "0";
                        this.activeClassName = "is-active";
                    }
                }
                else if (this.selectedStatusAbrv === "discharge") {
                    if (item.name === "Hospital" && this.facilityOrderPatient.activeStatus === "Hospital") {
                        this.inactiveOptionStoreId = "15";
                        this.hospitalClassName = "is-active";
                    }
                    else if (item.name === "Discharged" && this.facilityOrderPatient.activeStatus === "Discharged") {
                        this.inactiveOptionStoreId = "17";
                        this.dischargedClassName = "is-active";
                    }
                    else if (item.name === "Expired" && this.facilityOrderPatient.activeStatus === "Expired") {
                        this.inactiveOptionStoreId = "18";
                        this.expiredClassName = "is-active";
                    }
                    else if (item.name === "Active" && this.facilityOrderPatient.activeStatus !== "Hospital" && this.facilityOrderPatient.activeStatus !== "Discharged" && this.facilityOrderPatient.activeStatus !== "Expired") {
                        this.inactiveOptionStoreId = "0";
                        this.activeClassName = "is-active";
                    }
                }
                else if (this.selectedStatusAbrv === "intake-reviewed") {
                    if (item.name === "Active") {
                        this.inactiveOptionStoreId = "0";
                        this.activeClassName = "is-active";
                    }
                }
            });
    }

    @action.bound
    async openFacilityOrderTemplateItemNewFlowActivatePatientModal(inactiveOptionId, facilityOrderTemplates) {
        this.disabledPatient = true;
        if (this.selectedStatusAbrv === "in-progress") {
            this.pageViewStore.templatesToRemove.push(facilityOrderTemplates);
            this.removeTemplates(null, this.pageViewStore.templatesToRemove);
            this.pageViewStore.totalRecords -= 1;
        }
        if (inactiveOptionId === "0") {
            const facilityOrderStatus = this.facilityOrder.facilityOrderStatuses.find(i => i.status.abrv === 'us-intake');
            if (facilityOrderStatus && facilityOrderStatus.completedOn) {
                await this.activatePatient();
            }
            else {
                await this.setPatientStatus(inactiveOptionId === "15" ? "Hospital" : inactiveOptionId === "17" ? "Discharged" : inactiveOptionId === "18" ? "Expired" : "Active");
                await this.setInactiveOption("in-progress", inactiveOptionId);
            }
        }
        else {
            await this.setPatientStatus(inactiveOptionId === "15" ? "Hospital" : inactiveOptionId === "17" ? "Discharged" : inactiveOptionId === "18" ? "Expired" : "Active");
            await this.setInactiveOption("discharge", inactiveOptionId, true);
        }
        this.disabledPatient = false;
    }

    @action.bound
    async activatePatient() {
        if (this.facilityOrderPatient.eligibilityStatusId && this.facilityOrderPatient.isReviewed) {
            await this.pageViewStore.facilityOrderTemplateService.activateFacilityOrderTemplate({ facilityOrderPatientId: this.facilityOrderPatient.id, eligibilityStatusId: this.facilityOrderPatient.eligibilityStatusId });
            await this.setPatientStatus("Active");
            await this.fetchPatientTemplates();
        }
        else {
            await this.openFacilityOrderTemplateNewFlowUSIntakePatientActivationModal();
        }
    }

    @action.bound
    async setPatientStatus(status) {
        this.facilityOrderPatient.activeStatus = status;
        await this.pageViewStore.facilityOrderPatientService.update(this.facilityOrderPatient);
    }

    @action.bound
    async fetchPatientTemplates(fetchPatient = false, showDischarges = false, fetchTemplate = true) {
        const skipEnabling = this.disabledPatient;
        this.disabledPatient = true;

        if (fetchPatient) {
            let response = (await this.pageViewStore.facilityOrderPatientService.find({ rpp: 1, facilityOrderId: this.facilityOrder.id, patientId: this.facilityOrderPatient.patientId, embed: "EligibilityStatus,FacilityOrderPatientInitial,FacilityOrderPatientInitial.EligibilityStatus" })).data.item;
            if (response && response[0]) {
                if (this.facilityOrderPatient && response && response[0]) {
                    Object.keys(this.facilityOrderPatient).forEach(key => {
                        this.facilityOrderPatient[key] = response[0][key];
                    });
                }
            }
        }

        if (fetchTemplate) {
            await this.fetchTemplatesByPatientId();
            if (this.facilityOrderTemplates && this.facilityOrderTemplates.some(i => i.templateId)) {
                this.oldTemplate = this.facilityOrderTemplates.filter(i => i.templateId)[0];

                _.forEach(this.facilityOrderTemplates, (facilityOrderTemplate) => {
                    _.forEach(facilityOrderTemplate.facilityOrderTemplateItems, (facilityOrderTemplateItem) => {
                        facilityOrderTemplateItem.lastTemplateQuantity = facilityOrderTemplateItem.templateQuantity;
                        facilityOrderTemplateItem.lastOrderQuantity = facilityOrderTemplateItem.orderQuantity;
                        facilityOrderTemplateItem.lastNote = facilityOrderTemplateItem.note;
                    });
                });
            }
        }

        if (!skipEnabling) {
            this.disabledPatient = false;
        }

        if (showDischarges) {
            this.checkIsUSIntakeCompleted();
        }
        this.pageViewStore.showLoader = false;
    }

    @action.bound
    async openFacilityOrderTemplateNewFlowUSIntakePatientActivationModal() {
        this.pageViewStore.facilityOrderTemplateNewFlowUSIntakeTemplateActivationModal.open({
            facilityOrderPatient: this.facilityOrderPatient,
            patient: this.patient,
            setPatientStatus: async () => await this.setPatientStatus("Active"),
            fetchPatientTemplates: () => this.fetchPatientTemplates()
        });
    }

    @action.bound
    async setInactiveOption(newFlowStatusAbrv, inactiveOptionId, showDischarges = false) {
        _.each(this.facilityOrderTemplates, (item) => {
            item.inactiveReasonId = inactiveOptionId;
            item.inactiveReason = this.inactiveOptions.find((i) => i.id === inactiveOptionId).name;
        });
        this.getPatientStatusButtonClassName(inactiveOptionId);
        this.isTemplateActionAllowed();
        await this.saveInactiveReason(newFlowStatusAbrv, inactiveOptionId, showDischarges);
    }

    @action.bound
    isTemplateActionAllowed() {
        if (this.isHospitalStatus()) {
            this.isDisabledTableInactiveOption = true;
        }
        else {
            this.isDisabledTableInactiveOption = false;
        }
    }

    @action.bound
    isHospitalStatus() {
        if (this.facilityOrderTemplates.every(i => i.inactiveReason === 'Hospital')) {
            return true;
        }

        var templates = _.orderBy(this.facilityOrderTemplates, [item => (item.templateId === null ? 0 : item.templateId)], ['desc']);
        const gTubeSubCategory = this.lookups.subCategory.find(x => x.abrv == 'G-Tube');
        const trachTubSubCategory = this.lookups.subCategory.find(x => x.abrv == 'Trach-Tube');
        const noSubCategory = this.lookups.subCategory.find(x => x.abrv == 'No-Sub-Category');
        const enteralCategory = this.lookups.itemCategory.find(x => x.abrv == 'enteral');

        var template = templates.find(t => t.itemCategoryId == enteralCategory.id && t.subCategoryId != gTubeSubCategory.id);
        if (template) {
            return template.inactiveReason === 'Hospital';
        }

        template = templates.find(t => t.subCategoryId != gTubeSubCategory.id && t.subCategoryId != trachTubSubCategory.id && t.subCategoryId != noSubCategory.id);
        if (template) {
            return template.inactiveReason === 'Hospital';
        }

        return templates[0] && templates[0].inactiveReason === 'Hospital';
    }

    @action.bound
    async saveInactiveReason(statusAbrv, inactiveOptionId, showDischarges = false) {
        try {
            const status = this.lookups.newFlowStatus.find((s) => s.abrv === statusAbrv);
            const updatedItems = _.map(this.facilityOrderTemplates, (item) => {
                return {
                    id: item.id,
                    inactiveReasonId: inactiveOptionId,
                    isReviewed: item.isReviewed,
                    newFlowStatusId: statusAbrv === "intake-reviewed" ? item.newFlowStatusId : status.id,
                    newFlowStatusUpdatedByUserId: this.rootStore.userStore.user.id,
                    newFlowInsuranceStatusId: statusAbrv === "discharge" ? status.id : statusAbrv === "intake-reviewed" ? item.newFlowInsuranceStatusId : status.id,
                    portalNote: item.portalNote,
                    setInitialEligibility: item.setInitialEligibility,
                    newFlowUSIntakeStatusId: status.id,
                    setInactiveReason: true,
                    isTemplateStatus: false,
                    setStatuses: true,
                    setInsuranceStatus: false
                };
            });
            await this.pageViewStore.facilityOrderTemplateService.batchUpdate(updatedItems);
            await this.changeFacilityOrderTemplateStatus(this.facilityOrderTemplates.map(x => x.id), false);
            await this.fetchPatientTemplates(false, showDischarges);
        }
        catch (err) {
            this.rootStore.notificationStore.error("An unexpected error occurred while trying to update the template.", err);
        }
    }

    async changeFacilityOrderTemplateStatus(facilityOrderTemplateIds, setResponseData = true) {
        if (this.selectedStatusAbrv !== "discharge") {
            let facilityOrderTemplates = this.facilityOrderTemplates.filter(item => facilityOrderTemplateIds.some(id => id === item.id) && item.templateId);
            if (facilityOrderTemplates && facilityOrderTemplates.some(item => item.id)) {
                let response = await this.pageViewStore.facilityOrderTemplateService.changeTemplateStatus(facilityOrderTemplates.map(item => item.id));
                if (setResponseData && response && response.data && response.data.item && response.data.item[0]) {
                    for (const item of response.data.item) {
                        if (this.facilityOrderTemplates.find(x => x.id === item.id)) {
                            this.facilityOrderTemplates.find(x => x.id === item.id).newFlowUSIntakeStatusId = response.data.item[0].newFlowUSIntakeStatusId;
                            this.facilityOrderTemplates.find(x => x.id === item.id).newFlowUSIntakeStatus = this.lookups.newFlowStatus.find((s) => s.id === response.data.item[0].newFlowUSIntakeStatusId);
                            this.facilityOrderTemplates.find(x => x.id === item.id).newFlowStatusId = response.data.item[0].newFlowStatusId;
                            this.facilityOrderTemplates.find(x => x.id === item.id).newFlowStatus = this.lookups.newFlowStatus.find((s) => s.id === response.data.item[0].newFlowStatusId);
                        }
                    }
                }
            }
        }
    }

    @action.bound
    async openCreateFacilityOrderTemplateUSIntakeNewFlowModal() {
        const inactiveOption = this.getSelectedInactiveOption("insurance");
        const newFlowInsuranceStatusId = inactiveOption == "success" ? this.lookups.newFlowStatus.find((s) => s.abrv === "no-change").id : inactiveOption == "change" ? this.lookups.newFlowStatus.find((s) => s.abrv === "change").id : null;
        await this.pageViewStore.createFacilityOrderTemplateUSIntakeNewFlowModal.open({
            facilityOrderId: this.facilityOrder.id,
            patientId: this.patient.id,
            patientKey: this.patient.patientKey,
            patient: this.patient,
            facilityOrder: this.facilityOrder,
            newFlowInsuranceStatusId: newFlowInsuranceStatusId,
            isReviewed: this.selectedStatusAbrv === "intake-reviewed",
            isClinicalReviewed: (!this.facilityOrderPatient.eligibilityStatus || (this.facilityOrderPatient.eligibilityStatus && this.facilityOrderPatient.eligibilityStatus.name !== "Eligible")) && this.selectedStatusAbrv === "intake-reviewed",
            fetchPatientTemplates: () => this.fetchPatientTemplates()
        });
    }

    @action.bound
    getSelectedInactiveOption(option, facilityOrderTemplate) {
        if (option === "intake" && facilityOrderTemplate && facilityOrderTemplate.newFlowStatus) {
            if (facilityOrderTemplate.newFlowStatus.abrv === "change") {
                return "warning-triangle";
            }
            else if (facilityOrderTemplate.newFlowStatus.abrv === "no-change") {
                return "success";
            }
            else if (facilityOrderTemplate.newFlowStatus.abrv === "discharge" && this.facilityOrderTemplates) {
                return "danger";
            }
        }
        else if (option === "insurance") {
            if (this.facilityOrderTemplates.every((x) => x.newFlowInsuranceStatus && x.newFlowInsuranceStatus.abrv === "no-change")) {
                return "success";
            }
            else if (this.facilityOrderTemplates.every((x) => x.newFlowInsuranceStatus && x.newFlowInsuranceStatus.abrv === "change")) {
                return "change";
            }
        }
        else if (option === "us-intake" && facilityOrderTemplate && facilityOrderTemplate.newFlowStatus) {
            if ((!facilityOrderTemplate.templateId || (facilityOrderTemplate.newFlowStatus.abrv === "new-order" && (facilityOrderTemplate.importDetailStatus.abrv === 'imported' || facilityOrderTemplate.importDetailStatus.abrv === 'failed'))) && (facilityOrderTemplate.inactiveReasonId != 15 && facilityOrderTemplate.inactiveReasonId != 17 && facilityOrderTemplate.inactiveReasonId != 18)) {
                return "new";
            }
            else if (facilityOrderTemplate.newFlowStatus.abrv === "change") {
                return "warning-triangle";
            }
            else if (facilityOrderTemplate.newFlowStatus.abrv === "no-change") {
                return "success";
            }
            else if (facilityOrderTemplate.newFlowStatus.abrv === "discharge" && this.facilityOrderTemplates) {
                return "danger";
            }
        }
        return "";
    }

    @action.bound
    async reviewTemplates(facilityOrderTemplateId) {
        this.disabledPatient = true;
        await this.reviewActiveTemplates("intake-reviewed", facilityOrderTemplateId, true);
        this.disabledPatient = false;
    }

    @action.bound
    async unreviewTemplate(facilityOrderTemplateId) {
        this.disabledPatient = true;
        await this.reviewActiveTemplates("in-progress", facilityOrderTemplateId, false);
        this.disabledPatient = false;
    }

    @action.bound
    async reviewActiveTemplates(statusAbrv, templateId, isReview) {
        try {
            const status = this.lookups.newFlowStatus.find((s) => s.abrv === statusAbrv);
            const updatedItems = _.map(this.facilityOrderTemplates.filter((item) => !templateId || item.id === templateId), (item) => {
                return {
                    id: item.id,
                    inactiveReasonId: item.inactiveReasonId,
                    isReviewed: !isReview ? false : (isReview && templateId ? isReview : (isReview ? (item.newFlowUSIntakeStatus.abrv === "no-change" ? true : false) : item.isReviewed)),
                    newFlowStatusId: item.newFlowStatusId,
                    newFlowStatusUpdatedByUserId: this.rootStore.userStore.user.id,
                    newFlowInsuranceStatusId: statusAbrv === "intake-reviewed" || templateId ? item.newFlowInsuranceStatusId : status.id,
                    portalNote: item.portalNote,
                    newFlowUSIntakeStatusId: !isReview ? item.newFlowStatusId : (isReview && !templateId ? (item.newFlowUSIntakeStatus.abrv === "no-change" ? status.id : item.newFlowUSIntakeStatusId) : status.id),
                    changeTemplateStatus: isReview && (item.newFlowStatusId == this.lookups.newFlowStatus.find(s => s.abrv === "in-progress").id || item.newFlowStatusId == this.lookups.newFlowStatus.find(s => s.abrv === "change").id)
                };
            });

            const temp = updatedItems.filter(i => i.isReviewed == isReview);
            this.facilityOrderTemplates = this.facilityOrderTemplates.filter(i => !temp || !temp.some(t => t.id == i.id));

            this.pageViewStore.templatesToRemove.push(temp);

            await this.removeTemplates(templateId, this.pageViewStore.templatesToRemove);

            await this.pageViewStore.facilityOrderTemplateService.batchUpdate(updatedItems);

            await this.fetchTemplatePartialData(templateId, true);

        } catch (err) {
            this.rootStore.notificationStore.error("An unexpected error occurred while trying to update the template.");
        }
    }

    async removeTemplates(templateId, templatesToRemove) {
        this.groupByPatient = [];
        this.pageViewStore.groupByPatient = [];
        let patientGroups = [];
        this.pageViewStore.facilityOrderTemplatesGroupByPatient.forEach(obj => {
            let patientGroup = [];
            if (obj.facilityOrderTemplates) {
                obj.facilityOrderTemplates.forEach(template => {
                    patientGroup.push(template);
                })
            }
            patientGroups.push(patientGroup)
        });
        this.pageViewStore.groupByPatient = patientGroups;
        this.groupByPatient = patientGroups;
        if (templateId) {
            for (let i = 0; i < this.groupByPatient.length; i++) {
                const groupByPatientSubArray = this.groupByPatient[i];
                for (let k = groupByPatientSubArray.length - 1; k >= 0; k--) {
                    const groupByPatientObj = groupByPatientSubArray[k];

                    if (groupByPatientObj.id === templateId) {
                        groupByPatientSubArray[k] = null;
                        break;
                    }
                }
            }
        } else {
            for (let i = 0; i < this.groupByPatient.length; i++) {
                const groupByPatientSubArray = this.groupByPatient[i];

                for (let j = 0; j < templatesToRemove.length; j++) {
                    const idsSubArray = templatesToRemove[j];

                    for (let k = groupByPatientSubArray.length - 1; k >= 0; k--) {
                        const groupByPatientObj = groupByPatientSubArray[k];

                        for (let l = 0; l < idsSubArray.length; l++) {
                            const removeObj = idsSubArray[l];

                            if (groupByPatientObj.id === removeObj.id) {
                                groupByPatientSubArray.splice(k, 1);
                                break;
                            }
                        }
                    }
                }
            }
        }

        let allTemplatesEmpty = this.groupByPatient.every(subArray =>
            subArray.length === 0 || subArray.every(item => !item)
        );

        if (allTemplatesEmpty) {
            this.pageViewStore.showLoader = true;
        }
    }

    @action.bound
    async reviewDischargeTemplates(facilityOrderTemplateId) {
        this.disabledPatient = true;
        await this.saveTemplates(facilityOrderTemplateId, true);
        this.disabledPatient = false;
    }

    @action.bound
    async unreviewDischargeTemplates(facilityOrderTemplateId) {
        this.disabledPatient = true;
        this.saveTemplates(facilityOrderTemplateId, false);
        this.disabledPatient = false;
    }

    @action.bound
    async saveTemplates(facilityOrderTemplateId, isReviewed) {
        let updateItems = this.facilityOrderTemplates.filter((item) => !facilityOrderTemplateId || item.id === facilityOrderTemplateId);

        updateItems.forEach(item => {
            item.isReviewed = isReviewed;
        });
        await this.pageViewStore.facilityOrderTemplateService.batchUpdate(updateItems);
        await this.checkIsReviewed();
    }

    @action.bound
    async openFacilityOrderPatientNewFlowUSIntakeEligibilityStatusNoteModal() {
        this.pageViewStore.facilityOrderPatientNewFlowUSIntakeEligibilityStatusNoteModal.open({
            facilityOrderPatient: this.facilityOrderPatient
        });
    }

    @action.bound
    async setInsuranceStatus(newFlowStatusAbrv, isStatus = false) {
        if (newFlowStatusAbrv === "no-change") {
            await this.setNewFlowStatus(newFlowStatusAbrv, null, null, "insurance");
        } else if (newFlowStatusAbrv === "change") {
            await this.openFacilityOrderPatientNewFlowInsuranceNoteModal(newFlowStatusAbrv, isStatus);
        }
    }

    @action.bound
    async setNewFlowStatus(
        statusAbrv,
        templateId,
        inactiveOptionId = null,
        role = null,
        setInactiveReasonAndStatuses = false,
        changeTemplateStatus = true,
        changeFacilityOrderPatientInsuranceStatus = false,
        changeFacilityOrderTemplateStatus = false
    ) {
        this.disabledPatient = true;
        try {
            const status = this.lookups.newFlowStatus.find((s) => s.abrv === statusAbrv);
            let updateItems = this.facilityOrderTemplates.filter((item) => !templateId || item.id === templateId);

            const updatedItems = _.map(updateItems, (item) => {
                return {
                    id: item.id,
                    inactiveReasonId: statusAbrv === "discharge" && templateId ? 58 : inactiveOptionId != null ? inactiveOptionId : item.inactiveReasonId,
                    isReviewed: item.isReviewed,
                    newFlowStatusId: statusAbrv === "intake-reviewed" || role == "insurance" ? item.newFlowStatusId : status.id,
                    newFlowStatusUpdatedByUserId: this.rootStore.userStore.user.id,
                    newFlowInsuranceStatusId: statusAbrv === "discharge" ? status.id : statusAbrv === "intake-reviewed" || role == "intake" || templateId ? item.newFlowInsuranceStatusId : status.id,
                    portalNote: item.portalNote,
                    setInitialEligibility: item.setInitialEligibility,
                    newFlowUSIntakeStatusId: role === "insurance" ? item.newFlowUSIntakeStatusId : status.id,
                    setInactiveReason: setInactiveReasonAndStatuses,
                    isTemplateStatus: templateId ? true : false,
                    setStatuses: setInactiveReasonAndStatuses && !templateId ? true : false,
                    setInsuranceStatus: this.selectedStatusAbrv === "discharge" && statusAbrv !== "discharge" && templateId ? true : false
                };
            });

            await this.pageViewStore.facilityOrderTemplateService.batchUpdate(updatedItems);
            if (statusAbrv !== "discharge" && role !== "insurance" && changeTemplateStatus) {
                await this.changeFacilityOrderTemplateStatus(templateId ? [templateId] : this.facilityOrderTemplates.map(x => x.id));
            }

            if (changeFacilityOrderPatientInsuranceStatus) {
                await this.pageViewStore.facilityOrderPatientService.changeFacilityOrderPatientInsuranceStatus({ id: this.facilityOrderPatient.id });
            }

            if (changeFacilityOrderTemplateStatus) {
                await this.pageViewStore.facilityOrderTemplateService.changeTemplateStatus(updateItems.map(item => item.id));
            }
            await this.fetchPatientTemplates(true, (inactiveOptionId === 58 || (setInactiveReasonAndStatuses && !templateId) ? true : false));
        }
        catch (err) {
            this.rootStore.notificationStore.error("An unexpected error occurred while trying to update the template.", err);
        }
        this.disabledPatient = false;
    }

    @action.bound
    async openFacilityOrderPatientNewFlowInsuranceNoteModal(newFlowStatusAbrv, isStatus = false) {
        this.pageViewStore.facilityOrderPatientNewFlowInsuranceNoteModal.open({
            facilityOrderPatient: this.facilityOrderPatient,
            facilityOrderId: this.facilityOrder.id,
            patient: this.patient,
            facilityOrderTemplates: this.facilityOrderTemplates,
            setNewFlowStatus: async (changeFacilityOrderTemplateStatus) => await this.setNewFlowStatus(newFlowStatusAbrv, null, null, isStatus ? "insurance" : null, false, true, true, changeFacilityOrderTemplateStatus),
            // Reload the local patient (insurance) and the facility order patient so the backend-recomputed
            // "No OON Benefits" eligibility status note is displayed after the primary active insurance changes.
            refreshInsuranceData: async () => {
                await this.fetchPatient();
                await this.fetchPatientTemplates(true, false, false);
            },
            fetchPatientTemplates: async () => { await this.fetchPatientTemplates(true, false, false); await this.fetchTemplatePartialData(); },
            changeFacilityOrderPatientInsuranceStatus: () => this.changeFacilityOrderPatientInsuranceStatus(),
            showTemplateChangeWarning: (facilityOrderTemplate, checkEligibilityStatusChange, isEligibilityCheck, checkNonEligibilityStatusChange, isParUpdated) => this.showTemplateChangeWarning(facilityOrderTemplate, checkEligibilityStatusChange, isEligibilityCheck, checkNonEligibilityStatusChange, isParUpdated)
        });
    }

    @action.bound
    async fetchPatient() {
        if (this.patient) {
            let response = await this.pageViewStore.localPatientService.get(this.patient.id);
            this.patient = response.data;
            this.facilityOrderTemplates.forEach(x => { x.patient = response.data });
        }
    }

    @action.bound
    showTemplateChangeWarning(
        facilityOrderTemplate,
        checkEligibilityStatusChange,
        isEligibilityCheck = false,
        checkNonEligibilityStatusChange = false,
        isParUpdated = false
    ) {
        if (isParUpdated) {
            this.pageViewStore.templateChangeConfirmModal.open({
                message: "PAR flag was updated on a clinically reviewed template. Please ensure that the change you made is accounted for."
            });
            return;
        }

        let clinicalReviewFacilityOrderStatus = this.facilityOrder.facilityOrderStatuses.find(i => i.status.abrv === 'clinical-review');
        if (isEligibilityCheck && checkNonEligibilityStatusChange && clinicalReviewFacilityOrderStatus && clinicalReviewFacilityOrderStatus.completedOn) {
            this.pageViewStore.templateChangeConfirmModal.open({
                message: "Clinical review has been completed. Please ensure that the change you made is accounted for."
            });
            return;
        }

        if (!(this.facilityOrderPatient.activeStatus === "Active" && this.facilityOrderPatient.eligibilityStatus && this.facilityOrderPatient.eligibilityStatus.name === "Eligible")) {
            return;
        }

        if (isEligibilityCheck) {
            if (!facilityOrderTemplate && checkEligibilityStatusChange && this.facilityOrderTemplates.find(x => x.isClinicalReviewed)) {
                this.pageViewStore.templateChangeConfirmModal.open({
                    message: "At least one of this patient's templates has already been reviewed by Clinical Review. Please ensure that the change you made is accounted for."
                });
                return;
            }
        }
        else {
            if (facilityOrderTemplate && facilityOrderTemplate.isClinicalReviewed) {
                this.pageViewStore.templateChangeConfirmModal.open({
                    message: "This template has already been reviewed by Clinical Review. Please ensure that the change you made is accounted for."
                });
                return;
            }

            if (!facilityOrderTemplate && this.facilityOrderTemplates.find(x => x.isClinicalReviewed)) {
                this.pageViewStore.templateChangeConfirmModal.open({
                    message: "At least one of this patient's templates has already been reviewed by Clinical Review. Please ensure that the change you made is accounted for."
                });
            }
        }
    }

    @action.bound
    async openFacilityOrderTemplateNewFlowUSIntakeInsuranceQuestionModal() {
        this.pageViewStore.facilityOrderTemplateNewFlowUSIntakeInsuranceQuestionModal.open({
            patient: this.patient,
            facilityOrderPatient: this.facilityOrderPatient,
            showTemplateChangeWarning: () => this.showTemplateChangeWarning()
        });
    }

    @action.bound
    async openFacilityOrderPatientNewFlowInsuranceEditModal() {
        this.pageViewStore.facilityOrderPatientNewFlowInsuranceEditModal.open({
            patient: this.patient,
            // Reload the local patient (insurance) and the facility order patient so the backend-recomputed
            // "No OON Benefits" eligibility status note is displayed after the primary active insurance changes.
            refreshInsuranceData: async () => {
                await this.fetchPatient();
                await this.fetchPatientTemplates(true, false, false);
            },
            changeFacilityOrderPatientInsuranceStatus: () => this.changeFacilityOrderPatientInsuranceStatus(),
            facilityOrderPatient: this.facilityOrderPatient,
            facilityOrderTemplates: this.facilityOrderTemplates
        });
    }

    @action.bound
    async openFacilityOrderPatientNewFlowUSIntakeInsuranceInfoModal() {
        this.pageViewStore.facilityOrderPatientNewFlowUSIntakeInsuranceInfoModal.open({
            facilityOrderPatient: this.facilityOrderPatient,
            updateFacilityOrderPatient: () => this.updateFacilityOrderPatient(),
            changeInsuranceInfo: async (insuranceInfo) => {
                this.changeInsuranceInfo(insuranceInfo);
                // Reload the facility order patient so the backend-recomputed "Non-Billable Insurance" eligibility
                // status note is displayed after the modal saves the Insurance Info Note.
                await this.fetchPatientTemplates(true, false, false);
            }
        });
    }

    @action.bound
    async openFacilityOrderTemplateNewFlowInsuranceHistoryOfChangesModal() {
        this.pageViewStore.facilityOrderTemplateNewFlowInsuranceHistoryOfChangesModal.open({
            patient: this.patient,
            facilityOrderTemplates: this.facilityOrderTemplates,
            facilityOrderPatient: this.facilityOrderPatient
        });
    }

    @action.bound
    async openInsuranceInformation() {
        window.open(`${this.rootStore.applicationStore.app.baasic.settings.brightreeBaseUrl}Patient/frmPatientInsuranceRO.aspx?PatientKey=${this.patient.patientKey}&Edit=0`);
    }

    @action.bound
    async reviewPatient() {
        this.disabledPatient = true;
        this.facilityOrderPatient.isReviewed = !this.facilityOrderPatient.isReviewed;
        await this.updateFacilityOrderPatient();
        await this.changeFacilityOrderPatientInsuranceStatus(true);
        this.disabledPatient = false;
    }

    @action.bound
    async updateFacilityOrderPatient(isInsuranceInfo) {
        if (isInsuranceInfo) {
            this.facilityOrderPatient.insuranceInfo = this.insuranceInfo;
        }
        await this.pageViewStore.facilityOrderPatientService.update(this.facilityOrderPatient);
        if (isInsuranceInfo) {
            // Reload the facility order patient so the backend-recomputed "Non-Billable Insurance" eligibility
            // status note is displayed after the Insurance Info Note is saved.
            await this.fetchPatientTemplates(true, false, false);
        }
    }

    @action.bound
    changeInsuranceInfo(insuranceInfo) {
        this.insuranceInfo = insuranceInfo;
    }

    @action.bound
    async updateFacilityOrderPatientNote(id, note) {
        this.disabledPatient = true;
        await this.pageViewStore.facilityOrderPatientService.updateNote({ id, note });
        this.facilityOrderPatient.note = this.patientNote;
        await this.changeFacilityOrderPatientInsuranceStatus();
        this.disabledPatient = false;
    }

    @action.bound
    async changePatientNote(patientNote) {
        this.patientNote = patientNote;
    }

    async changeFacilityOrderPatientInsuranceStatus(insuranceReview = false) {
        if (this.selectedStatusAbrv !== "discharge" && !this.facilityOrderPatient.isNewPatient) {
            let response = await this.pageViewStore.facilityOrderPatientService.changeFacilityOrderPatientInsuranceStatus({ id: this.facilityOrderPatient.id, insuranceReview: insuranceReview });
            if (response && response.data && response.data.item && this.facilityOrderTemplates.length > 0) {
                for (const item of response.data.item) {
                    if (this.facilityOrderTemplates.find(x => x.id === item.id)) {
                        this.facilityOrderTemplates.find(x => x.id === item.id).newFlowInsuranceStatusId = item.newFlowInsuranceStatusId;
                        this.facilityOrderTemplates.find(x => x.id === item.id).newFlowInsuranceStatus = this.lookups.newFlowStatus.find((s) => s.id === item.newFlowInsuranceStatusId);
                    }
                }
            }
        }
    }

    @action.bound
    async activateTemplate(facilityOrderTemplateId) {
        this.disabledPatient = true;
        if (this.facilityOrderPatient.eligibilityStatusId != null && (await this.hasPatientActiveTemplate())) {
            await this.pageViewStore.facilityOrderTemplateService.activateFacilityOrderTemplate({ id: facilityOrderTemplateId, facilityOrderPatientId: this.facilityOrderPatient.id, eligibilityStatusId: this.facilityOrderPatient.eligibilityStatusId });
            await this.fetchPatientTemplates();
        }
        else {
            await this.openFacilityOrderTemplateNewFlowUSIntakeTemplateActivationModal(facilityOrderTemplateId);
        }
        this.disabledPatient = false;
    }

    @action.bound
    async hasPatientActiveTemplate() {
        let statusIds = _.map(_.filter(this.lookups.newFlowStatus, s => s.abrv === "change" || s.abrv === "no-change"), (s => { return s.id }));
        let params = {
            pageSize: 1,
            facilityOrderId: this.facilityOrder.id,
            patientId: this.patient.id,
            isReviewed: true,
            fields: "id",
            newFlowInsuranceStatusIds: statusIds.join(",")
        }

        if (this.facilityOrder.isEnteralWeek) {
            params = _.extend(params, {
                itemCategoryIds: [this.lookups.itemCategory.find(x => x.abrv == 'enteral').id]
            });
        }

        const response = await this.pageViewStore.facilityOrderTemplateService.find(params);
        return response.data.item && response.data.item.some(i => i);
    }

    @action.bound
    async openFacilityOrderTemplateNewFlowUSIntakeTemplateActivationModal(facilityOrderTemplateId) {
        let facilityOrderTemplate = this.facilityOrderTemplates.find((item) => item.id === facilityOrderTemplateId);
        this.pageViewStore.facilityOrderTemplateNewFlowUSIntakeTemplateActivationModal.open({
            facilityOrderTemplate: facilityOrderTemplate,
            facilityOrderPatient: this.facilityOrderPatient,
            patient: this.patient,
            fetchPatientTemplates: () => this.fetchPatientTemplates()
        });
    }

    @action.bound
    async setTemplateStatus(
        newFlowStatusAbrv,
        facilityOrderTemplateId,
        inactiveReasonId = null,
        setInactiveReasonAndStatuses = false
    ) {
        await this.setNewFlowStatus(newFlowStatusAbrv, facilityOrderTemplateId, inactiveReasonId, "intake", setInactiveReasonAndStatuses);
    }

    @action.bound
    async updatePortalNote(id, portalNote) {
        await this.pageViewStore.facilityOrderTemplateService.updatePortalNote({ id, portalNote });
    }

    @action.bound
    changeItemsVisibility(facilityOrderTemplate) {
        facilityOrderTemplate.itemsVisible = !facilityOrderTemplate.itemsVisible;
    }

    @action.bound
    editItem(facilityOrderTemplateItem, value, propertyName) {
        facilityOrderTemplateItem[propertyName] = value;
        if (propertyName === "templateQuantity") {
            facilityOrderTemplateItem["orderQuantity"] = value
        }
    }

    @action.bound
    async updateItem(
        facilityOrderTemplateItem,
        facilityOrderTemplate,
        isNote,
        isTemplateQuantityUpdate = false
    ) {
        if (facilityOrderTemplateItem.templateQuantity == facilityOrderTemplateItem.lastTemplateQuantity &&
            facilityOrderTemplateItem.orderQuantity == facilityOrderTemplateItem.lastOrderQuantity &&
            facilityOrderTemplateItem.note == facilityOrderTemplateItem.lastNote) {
            return;
        }

        if (facilityOrderTemplateItem.orderQuantity < facilityOrderTemplateItem.sendSeparatelyQty) {
            this.rootStore.notificationStore.error("An SS has already been applied to this item. The sales order qty cannot be lower than the SS qty.");
            facilityOrderTemplateItem.orderQuantity = facilityOrderTemplateItem.lastOrderQuantity;
            facilityOrderTemplateItem.templateQuantity = facilityOrderTemplateItem.lastTemplateQuantity;
            return;
        }

        this.disabledPatient = true;
        const importActionDelete = this.lookups.importAction.find(x => x.abrv === "delete");
        if (facilityOrderTemplateItem.templateItemId && facilityOrderTemplateItem.importActionId != importActionDelete.id) {
            facilityOrderTemplateItem.importAction = this.lookups.importAction.find(x => x.abrv === "update");
            facilityOrderTemplateItem.importActionId = facilityOrderTemplateItem.importAction.id;
        }

        if ((isNote && facilityOrderTemplateItem.lastNoteValue != facilityOrderTemplateItem.note) || (isTemplateQuantityUpdate && facilityOrderTemplateItem.lastTemplateQuantityValue != facilityOrderTemplateItem.templateQuantity)) {
            this.showTemplateChangeWarning(facilityOrderTemplate);
            facilityOrderTemplateItem.lastTemplateQuantityValue = facilityOrderTemplateItem.templateQuantity;
            facilityOrderTemplateItem.lastNoteValue = facilityOrderTemplateItem.note;
        }
        let change = false;
        if (isNote) {
            await this.pageViewStore.facilityOrderTemplateItemService.update(facilityOrderTemplateItem);
            if (facilityOrderTemplateItem.facilityOrderTemplateItemInitial && facilityOrderTemplateItem.note != facilityOrderTemplateItem.facilityOrderTemplateItemInitial.note)
            {
                if(!facilityOrderTemplateItem.isNoteChanged){
                    change = true;
                    facilityOrderTemplateItem.isNoteChanged = true;
                }
            }
            else
                facilityOrderTemplateItem.isNoteChanged = false;

            facilityOrderTemplateItem.lastNote = facilityOrderTemplateItem.note;
        }
        else {
            let result = await this.pageViewStore.facilityOrderTemplateItemService.newUpdate(facilityOrderTemplateItem);
            if (result) {
                facilityOrderTemplateItem.orderQuantity = result.orderQuantity;
                facilityOrderTemplateItem.templateQuantity = result.templateQuantity;
                facilityOrderTemplateItem.importActionId = result.importActionId;

                facilityOrderTemplateItem.lastTemplateQuantity = facilityOrderTemplateItem.templateQuantity;
                facilityOrderTemplateItem.lastOrderQuantity = facilityOrderTemplateItem.orderQuantity;
                facilityOrderTemplateItem.lastNote = facilityOrderTemplateItem.note;

                if (facilityOrderTemplateItem.importActionId) {
                    const importAction = this.lookups.importAction.find(x => x.id === facilityOrderTemplateItem.importActionId);
                    facilityOrderTemplateItem.importAction = importAction;
                }
                facilityOrderTemplate.isDifferentQty = result.isDifferentQty;

                await this.changeFacilityOrderTemplateStatus([facilityOrderTemplate.id]);

                if (facilityOrderTemplateItem.facilityOrderTemplateItemInitial && result.templateQuantity != facilityOrderTemplateItem.facilityOrderTemplateItemInitial.templateQuantity)
                {
                    if(!facilityOrderTemplateItem.isTemplateQuantityChanged){
                        change = true;
                        facilityOrderTemplateItem.isTemplateQuantityChanged = true;
                    }
                }
                else
                    facilityOrderTemplateItem.isTemplateQuantityChanged = false;

                if (facilityOrderTemplateItem.facilityOrderTemplateItemInitial && result.orderQuantity != facilityOrderTemplateItem.facilityOrderTemplateItemInitial.orderQuantity)
                {
                    if(!facilityOrderTemplateItem.isOrderQuantityChanged){
                        change = true;
                        facilityOrderTemplateItem.isOrderQuantityChanged = true;
                    }
                }
                else
                    facilityOrderTemplateItem.isOrderQuantityChanged = false;
            }
        }

        if(change)
        {
            this.isQtyChange = true;
            this.isQtyChange = false;
        }

        this.disabledPatient = false;

        this.pageViewStore.isDropdownOpen = false;
    }

    @action.bound
    openFacilityOrderTemplateItemNewFlowCalculationModal(
        facilityOrderTemplateItems,
        index,
        showWarningModal = true,
        changeStatus = true
    ) {
        let facilityOrderTemplate = this.facilityOrderTemplates.find(item => item.id === facilityOrderTemplateItems[index].facilityOrderTemplateId);
        this.pageViewStore.facilityOrderTemplateItemNewFlowCalculationModal.open({
            facilityOrderTemplateItem: facilityOrderTemplateItems[index],
            facilityOrderTemplate: facilityOrderTemplate,
            lookups: this.lookups,
            facilityOrderId: this.facilityOrder.id,
            isUpdate: true,
            showWarningModal: showWarningModal,
            showTemplateChangeWarning: () => this.showTemplateChangeWarning(facilityOrderTemplate),
            changeFacilityOrderTemplateStatus: () => changeStatus ? this.changeFacilityOrderTemplateStatus([facilityOrderTemplate.id]) : {}
        });
    }

    @action.bound
    async setImportAction(facilityOrderTemplateItem, action) {
        const skipEnabling = this.disabledPatient;
        this.disabledPatient = true;

        facilityOrderTemplateItem.importAction = this.lookups.importAction.find(x => x.abrv === action);
        facilityOrderTemplateItem.importActionId = facilityOrderTemplateItem.importAction.id;
        await this.pageViewStore.facilityOrderTemplateItemService.update(facilityOrderTemplateItem);

        if (this.facilityOrderTemplates.find(i => i.id === facilityOrderTemplateItem.facilityOrderTemplateId)) {
            this.setDifferentQty(this.facilityOrderTemplates.find(i => i.id === facilityOrderTemplateItem.facilityOrderTemplateId), "IsDifferentQty");
        }

        this.changeFacilityOrderTemplateStatus([facilityOrderTemplateItem.facilityOrderTemplateId]);
        this.showTemplateChangeWarning(this.facilityOrderTemplates.find(i => i.id === facilityOrderTemplateItem.facilityOrderTemplateId));
        if (!skipEnabling) this.disabledPatient = false;
    }

    @action.bound
    async deleteFacilityOrderTemplateItem(facilityOrderTemplateItems, index, facilityOrderTemplateId) {
        const skipEnabling = this.disabledPatient;
        this.disabledPatient = true;

        if (facilityOrderTemplateItems[index].templateItemId) {
            await this.setImportAction(facilityOrderTemplateItems[index], 'delete');
        }
        else {
            if (this.facilityOrderPatient.isNewPatient && this.facilityOrderTemplates.length == 1 && facilityOrderTemplateItems.length == 1) {
                let params = { facilityOrderId: this.facilityOrder.id, patientId: this.patient.id, rpp: 2, fields: "id" };
                if (this.facilityOrder.isEnteralWeek) {
                    params = _.extend(params, {
                        itemCategoryIds: [this.lookups.itemCategory.find(x => x.abrv == 'enteral').id]
                    });
                }
                var response = (await this.pageViewStore.facilityOrderTemplateService.find(params)).data.item;
                if (response.length == 1) {
                    this.pageViewStore.facilityOrderTemplateItemNewFlowDeleteQuestionModal.open({
                        deleteItem: () => this.deleteItem(facilityOrderTemplateItems, index, facilityOrderTemplateId, false),
                        deletePatient: () => this.deleteItem(facilityOrderTemplateItems, index, facilityOrderTemplateId, true)
                    });
                    if (!skipEnabling) this.disabledPatient = false;
                    return;
                }
            }
            await this.deleteItem(facilityOrderTemplateItems, index, facilityOrderTemplateId, true);
            this.changeFacilityOrderTemplateStatus([facilityOrderTemplateId]);
            this.showTemplateChangeWarning(this.facilityOrderTemplates.find(i => i.id === facilityOrderTemplateId));
        }

        if (!skipEnabling) this.disabledPatient = false;

        this.pageViewStore.isDropdownOpen = false;
    }

    @action.bound
    async deleteItem(facilityOrderTemplateItems, index, facilityOrderTemplateId, deleteTemplate) {
        const isNewProduct = facilityOrderTemplateItems[index].product != null;
        if (isNewProduct) {
            const facilityOrderLinkedTemplateId = this.facilityOrderTemplates.find(i => i.id === facilityOrderTemplateId).linkedTemplateId;
            const isInnerCannula = facilityOrderTemplateItems[index].product.innerCannulaId != null;

            try {
                await this.pageViewStore.facilityOrderTemplateItemService.newDelete(facilityOrderTemplateItems[index]);
            } catch (ex) {
                if (ex && ex.data.includes("FK_InventoryCalculationCutback_FacilityOrderTemplateItem")) {
                    this.rootStore.notificationStore.error("Template item cannot be deleted because it is included in the Inventory Calculation.");
                }
                else {
                    this.rootStore.notificationStore.error("An unexpected error occurred while trying to delete the item.");
                }
                return;
            }

            if (facilityOrderLinkedTemplateId && isInnerCannula) {
                await this.fetchPatientTemplates();
            }

        }
        facilityOrderTemplateItems.splice(index, 1);
        if (deleteTemplate && facilityOrderTemplateItems.length === 0) {
            await this.deleteTemplate(facilityOrderTemplateId);
        }

        if (isNewProduct && this.facilityOrderTemplates.find(i => i.id === facilityOrderTemplateId)) {
            this.setDifferentQty(this.facilityOrderTemplates.find(i => i.id === facilityOrderTemplateId), "IsDifferentQty");
        }
    }

    @action.bound
    isDisabledTemplateReview(facilityOrderTemplate) {
        if (this.facilityOrderTemplates.some(x => x.newFlowInsuranceStatus.abrv === "in-progress")) {
            return true;
        }
        else if (!facilityOrderTemplate.templateId && (facilityOrderTemplate.inactiveReasonId != 15 && facilityOrderTemplate.inactiveReasonId != 17 && facilityOrderTemplate.inactiveReasonId != 18))
            return false;
    }

    @action.bound
    async openFacilityOrderTemplateNewFlowUSIntakeMissingProductNoteModal(facilityOrderTemplate) {
        if (!facilityOrderTemplate.missingProduct) {
            await this.pageViewStore.facilityOrderTemplateService.updateMissingProduct({
                id: facilityOrderTemplate.id
            });
            facilityOrderTemplate.missingProduct = true;
        }

        this.pageViewStore.facilityOrderTemplateNewFlowUSIntakeMissingProductNoteModal.open({
            facilityOrderTemplate: facilityOrderTemplate,
            showTemplateChangeWarning: () => this.showTemplateChangeWarning(facilityOrderTemplate)
        });
    }

    @action.bound
    async openFacilityOrderTemplateNewFlowUSIntakePortalNoteModal(facilityOrderTemplate) {
        this.pageViewStore.facilityOrderTemplateNewFlowUSIntakePortalNoteModal.open({
            facilityOrderTemplateId: facilityOrderTemplate.id,
            refreshPortalNote: (portalNote) => (facilityOrderTemplate.portalNote = portalNote),
            isIntakeReviewed: this.selectedStatusAbrv === "intake-reviewed"
        });
    }

    @action.bound
    async openFacilityOrderTemplateDoNotSupplyModal(facilityOrderTemplate) {
        this.pageViewStore.facilityOrderTemplateDoNotSupplyModal.open({
            title: `${facilityOrderTemplate.inactiveReasonId == 16 ? "Unmark" : "Mark"} As Do Not Supply`,
            description: `Are you sure you want to ${facilityOrderTemplate.inactiveReasonId == 16 ? "unmark" : "mark"} this order as Do not supply?`,
            markDoNotSupply: () => this.markDoNotSupply(facilityOrderTemplate),
            showTemplateChangeWarning: () => this.showTemplateChangeWarning(facilityOrderTemplate)
        });
    }

    @action.bound
    async markDoNotSupply(facilityOrderTemplate) {
        await this.pageViewStore.facilityOrderTemplateService.setDoNotSupply(facilityOrderTemplate);
        facilityOrderTemplate.inactiveReasonId = facilityOrderTemplate.inactiveReasonId == 16 ? 0 : 16;
    }

    @action.bound
    async openFacilityOrderTemplateNewFlowUSIntakeClinicalInformationModal(facilityOrderTemplate) {
        this.pageViewStore.facilityOrderTemplateNewFlowUSIntakeClinicalInformationModal.open({
            facilityOrderTemplate: facilityOrderTemplate,
            facilityOrderPatient: this.facilityOrderPatient,
            facilityOrder: this.facilityOrder,
            patient: this.patient,
            lookups: this.lookups,
            isEligible: this.facilityOrderPatient.eligibilityStatus && this.facilityOrderPatient.eligibilityStatus.name === "Eligible",
            setDifferentQty: () => this.setDifferentQty(facilityOrderTemplate, "IsDifferentQty,IsDoNotSupply"),
            setIsQtyChange: () => { this.isQtyChange = true; this.isQtyChange = false; }
        });
    }

    @action.bound
    async setDifferentQty(facilityOrderTemplate, embed) {
        const response = await this.pageViewStore.facilityOrderTemplateService.getFacilityOrderTemplateValidation(facilityOrderTemplate.id, { embed: embed });
        runInAction(() => {
            if (response && response.data && embed) {
                if (embed.includes('IsDoNotSupply')) {
                    facilityOrderTemplate.isDoNotSupply = response.data.isDoNotSupply;
                }
                if (embed.includes('IsDifferentQty')) {
                    facilityOrderTemplate.isDifferentQty = response.data.isDifferentQty;
                }
            }
        });
    }

    @action.bound
    async openFacilityOrderTemplateNewFlowDeleteModal(facilityOrderTemplateId) {
        this.pageViewStore.facilityOrderTemplateNewFlowDeleteModal.open({
            item: this.facilityOrderTemplates.find(i => i.id === facilityOrderTemplateId),
            deleteTemplate: () => this.deleteTemplate(facilityOrderTemplateId),
            numberOfTemplates: () => { return this.facilityOrderTemplates.length },
            isNewPatient: this.facilityOrderPatient.isNewPatient
        });
    }

    @action.bound
    async deleteTemplate(facilityOrderTemplateId) {
        const skipEnabling = this.disabledPatient;
        this.disabledPatient = true;
        try {
            await this.pageViewStore.facilityOrderTemplateService.deleteNewTemplate(facilityOrderTemplateId);
            this.facilityOrderTemplates.splice(this.facilityOrderTemplates.indexOf(this.facilityOrderTemplates.find((i) => i.id === facilityOrderTemplateId)), 1);
            await this.fetchPatientTemplates(false, true);
        } catch (err) {
            this.rootStore.notificationStore.error("Error occurred while trying to delete a template.");
        }
        if (!skipEnabling) {
            this.disabledPatient = false;
        }
    }

    @action.bound
    async addEmptyItem(facilityOrderTemplateId) {
        this.facilityOrderTemplates.forEach(template => {
            template.facilityOrderTemplateItems = template.facilityOrderTemplateItems.filter(
                item => !!item.product
            );
        });

        const facilityOrderTemplate = this.facilityOrderTemplates.find(
            item => item.id === facilityOrderTemplateId
        );

        await this.setProductStore(facilityOrderTemplate.subCategoryId);

        facilityOrderTemplate.facilityOrderTemplateItems.push({
            id: uuid(),
            note: null,
            product: null,
            productId: null,
            procedureCode: null,
            mlph: undefined,
            frequency: undefined,
            itemCals: 0,
            itemMls: 0,
            templateQuantity: null,
            orderQuantity: 0,
            importActionId: this.lookups.importAction.find(x => x.abrv === 'insert').id,
            importDetailStatusId: this.lookups.importDetailStatus.find(x => x.abrv === 'new').id,
            facilityOrderTemplateId: facilityOrderTemplateId,
        });

        this.pageViewStore.isDropdownOpen = true;
    }

    @action.bound
    async setProductStore(subCategoryId) {
        const ostomySubCategory = this.lookups.subCategory.find((x) => x.abrv == "Ostomy-Products");
        const isOstomySubCategory = subCategoryId === ostomySubCategory.id;

        this.productStore = new BaasicDropdownStore(
            {
                filterable: true,
                textField: "itemId",
            },
            {
                fetchFunc: async (term) => {
                    if ((term && term.trim()) === '')
                        term = undefined;

                    let params = {
                        searchQuery: term,
                        rpp: 50,
                        subCategoryId: subCategoryId,
                        isActive: true,
                        embed: "Product,Product.ItemType,Product.ItemCategory,Product.SubCategory,Product.UnitOfMeasure,Product.ProcedureCode_",
                    };

                    if (isOstomySubCategory) {
                        params = { ...params, sort: "isPreferred|desc" };
                    }

                    const response = await this.pageViewStore.itemSubcategoryService.find(params);
                    let filteredProducts = this.isMasterPatient ? response.data.item : response.data.item.filter((x) => !x.product.itemId.toLowerCase().includes("-cs"));

                    return _.map(filteredProducts, (item) => { return { ...item.product }; });
                },
            }
        );
    }

    @action.bound
    async saveItemOnProductSelect(
        facilityOrderTemplateItem,
        facilityOrderTemplateItems,
        index,
        product,
        facilityOrderTemplate
    ) {
        this.disabledPatient = true;
        try {
            const trachTubeSubCategoryId = this.lookups.subCategory.find(x => x.abrv == 'Trach-Tube').id;
            const deleteImportActionId = this.lookups.importAction.find(x => x.abrv == 'delete').id;
            if (facilityOrderTemplate.templateId && facilityOrderTemplate.subCategoryId === trachTubeSubCategoryId && facilityOrderTemplateItems.some(x => x.productId && x.importActionId !== deleteImportActionId)) {
                this.rootStore.modalStore.showConfirm('FACILITY_ORDER_TEMPLATE.EDIT.CONFIRM_DELTE_TRACH_TUBE_ITEMS', async () => {
                    await this.saveItem(facilityOrderTemplateItem, facilityOrderTemplateItems, index, product, facilityOrderTemplate, true);
                    this.changeFacilityOrderTemplateStatus([facilityOrderTemplate.id]);
                });
            }
            else {
                await this.saveItem(facilityOrderTemplateItem, facilityOrderTemplateItems, index, product, facilityOrderTemplate);
                this.changeFacilityOrderTemplateStatus([facilityOrderTemplate.id]);
            }

        } catch (err) {
            this.rootStore.notificationStore.error(err.data ? err.data : "FACILITY_ORDER_TEMPLATE_ITEM.EDIT.ERROR");
        }
        this.disabledPatient = false;
    }

    @action.bound
    async saveItem(
        facilityOrderTemplateItem,
        facilityOrderTemplateItems,
        index,
        product,
        facilityOrderTemplate,
        refreshTemplates = false
    ) {
        if (product) {
            let tempItem = {
                product: product,
                productId: product.id,
                procedureCode: product.procedureCode_ && product.procedureCode_.abrv,
                importActionId: facilityOrderTemplateItem.importActionId,
                importDetailStatusId: facilityOrderTemplateItem.importDetailStatusId,
                facilityOrderTemplateId: facilityOrderTemplate.id,
            };

            const isEnteral = this.lookups.itemCategory.some((i) => i.id === facilityOrderTemplate.itemCategoryId && i.abrv.includes("enteral"));
            const itemType = (product.itemType && (product.itemType.abrv === "bottle" || product.itemType.abrv === "can")) || (product.procedureCode_ && product.procedureCode_.abrv === "B4155");
            if (!this.isMasterPatient && isEnteral && itemType) {
                _.extend(tempItem, { itemMls: 1, itemCals: product.calsPerMl });
            }

            const response = await this.pageViewStore.facilityOrderTemplateItemService.createAdditionalItemsNewFlow(
                {
                    facilityOrderId: this.facilityOrder.id,
                    facilityOrderItem: tempItem,
                    facilityOrderItems: facilityOrderTemplateItems.filter((i) => i.product).map((i) => { return { product: i.product, productId: i.productId, procedureCode: i.procedureCode, importActionId: i.importActionId }; }),
                    subCategoryId: facilityOrderTemplate.subCategoryId,
                    clinicalStatusId: facilityOrderTemplate.clinicalStatusId,
                    isMasterPatient: this.isMasterPatient
                }
            );

            if (refreshTemplates || (tempItem.product.innerCannulaId && facilityOrderTemplate.linkedTemplateId == null)) {
                await this.fetchPatientTemplates();
                return;
            }

            this.addItem(facilityOrderTemplateItems, response, index, facilityOrderTemplate);

            if (!this.isMasterPatient && isEnteral && itemType) {
                index = facilityOrderTemplateItems.indexOf(facilityOrderTemplateItems.slice(index).find(i => i.productId == tempItem.productId));
                this.openFacilityOrderTemplateItemNewFlowCalculationModal(facilityOrderTemplateItems, index, false, false);
            }
        }

        this.pageViewStore.isDropdownOpen = false;
    }

    @action.bound
    async addItem(facilityOrderTemplateItems, items, index, facilityOrderTemplate) {
        this.showTemplateChangeWarning(facilityOrderTemplate);

        facilityOrderTemplateItems.splice(index);
        _.each(items, i => {
            facilityOrderTemplateItems.push({
                id: i.id,
                note: i.note,
                product: i.product,
                productId: i.product.id,
                procedureCode: i.procedureCode,
                mlph: i.mlph,
                frequency: i.frequency,
                itemCals: i.itemCals,
                itemMls: i.itemMls,
                templateQuantity: i.templateQuantity,
                orderQuantity: i.orderQuantity,
                importActionId: i.importActionId,
                importDetailStatusId: i.importDetailStatusId,
                facilityOrderTemplateId: i.facilityOrderTemplateId,
            });
        });
    }

    @action.bound
    async setImportActionToDeleteAndAddItem(item, facilityOrderTemplateItems, index, facilityOrderTemplateId) {
        this.disabledPatient = true;
        try {
            if (item.importAction && item.importAction.name === "Delete") {
                await this.setImportAction(item, "update")
            }
            else {
                await this.deleteFacilityOrderTemplateItem(facilityOrderTemplateItems, index, facilityOrderTemplateId)
                this.addEmptyItem(item.facilityOrderTemplateId);
            }
        }
        catch (err) {
            this.rootStore.notificationStore.error("FACILITY_ORDER_TEMPLATE_ITEM.EDIT.DELETE_ERROR");
        }
        this.disabledPatient = false;
    }

    @action.bound
    showItemQuantities(facilityOrderTemplate, show) {
        this.templateExpanded = { id: facilityOrderTemplate.id, expanded: show }
    }

    @action.bound
    async openFacilityOrderTemplateNewFlowInvoiceNoteModal(facilityOrderTemplate) {
        this.pageViewStore.facilityOrderTemplateNewFlowInvoiceNoteModal.open({
            facilityOrderTemplate: facilityOrderTemplate
        });
    }
}

export default FacilityOrderPatientNewFlowUSIntakeSinglePagePreviewViewStore;
